import { render, staticRenderFns } from "./chatInterface.vue?vue&type=template&id=7e0b310e&scoped=true"
import script from "./chatInterface.vue?vue&type=script&lang=js"
export * from "./chatInterface.vue?vue&type=script&lang=js"
import style0 from "./chatInterface.vue?vue&type=style&index=0&id=7e0b310e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0b310e",
  null
  
)

export default component.exports